import mod from "-!./tabSpr.js?vue&type=script&lang=js&external"; export default mod; export * from "-!./tabSpr.js?vue&type=script&lang=js&external"